import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function (languages) {
    const response = await api.get(endpoints.attributeManager.attributeTypes.get, {
      params: { languages }
    });
    return response.data;
  },
  update: async function (model) {
    const response = await api.post(endpoints.attributeManager.attributeTypes.update, model);
    return response.data;
  },
  delete: async function (items) {
    const response = await api.post(endpoints.attributeManager.attributeTypes.delete, items);
    return response.data;
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api
      .post(endpoints.attributeManager.attributeTypes.deepL, model, { params: { sourceLanguage: sourceLanguage } })
      .then((x) => Promise.resolve(x.data));
  }
};
